module.exports = __webpack_public_path__ + "assets/fonts/iconfont.75fda936.ttf";